import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

export const query = gql`
  query Homepages($limit: Int, $cursor: String, $ids: [String!], $state: HomepageState, $kind: HomepageKind) {
    homepages(limit: $limit, cursor: $cursor, ids: $ids, state: $state, kind: $kind) {
      results {
        uuid
        name
        bannerTagId
        topCategoriesId
        lanes {
          type
          query {
            limit
            tagIds
            type
            sort
            q
          }
        }
      }
    }
  }
`

export const homepageListNoDealsKey = getQueryNames(query)[0]

export default query
